/* CS Reviews: "Bekijk meer reviews" toont er telkens 3 bij (mobiel start op 3,
   desktop op 6) en verdwijnt zodra alles zichtbaar is. De zichtbaarheid zelf
   regelt de CSS via data-stap; JS telt alleen op en beheert de knop. */
(() => {
  if (window.__csReviewsInit) return;
  window.__csReviewsInit = true;

  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const STAP = 3;
  const MAX_STAP = 4; /* hoogste waarde die de CSS afdekt (15 reviews) */

  const init = (root) => {
    const grid = root.querySelector('[data-cs-reviews-grid]');
    const knop = root.querySelector('[data-cs-reviews-meer]');
    if (!grid || !knop || knop.dataset.csInit === '1') return;
    knop.dataset.csInit = '1';

    const kaarten = grid.querySelectorAll('.cs-reviews__kaart');
    const rij = knop.closest('.cs-reviews__knoprij') || knop;

    /* De basis staat op de grid: compact (homepage) begint op 3, uitgebreid
       (PDP) op 6 desktop. Mobiel begint alles op 3. */
    const zichtbaar = () => {
      const stap = parseInt(grid.dataset.stap, 10) || 0;
      const basis = DESKTOP.matches
        ? parseInt(grid.dataset.basisDesktop, 10) || 3
        : parseInt(grid.dataset.basisMobiel, 10) || 3;
      return Math.min(basis + stap * STAP, kaarten.length);
    };

    const werkKnopBij = () => {
      rij.hidden = zichtbaar() >= kaarten.length;
    };

    knop.addEventListener('click', () => {
      const stap = parseInt(grid.dataset.stap, 10) || 0;
      grid.dataset.stap = String(Math.min(stap + 1, MAX_STAP));

      /* De knop kan verdwijnen; focus naar de eerste nieuw getoonde kaart zodat
         een toetsenbordgebruiker niet op een verborgen element achterblijft. */
      const eerste = kaarten[Math.min(zichtbaar() - STAP, kaarten.length - 1)];
      if (eerste) {
        eerste.setAttribute('tabindex', '-1');
        eerste.focus({ preventScroll: true });
      }
      werkKnopBij();
    });

    /* Bij het wisselen van breakpoint verandert het aantal zichtbare kaarten,
       en daarmee of de knop nog nodig is. */
    const opWissel = () => werkKnopBij();
    if (DESKTOP.addEventListener) {
      DESKTOP.addEventListener('change', opWissel);
    } else {
      DESKTOP.addListener(opWissel);
    }

    werkKnopBij();
  };

  const initAll = (scope) => {
    (scope || document).querySelectorAll('.cs-reviews').forEach(init);
  };

  /* Het sectiescript kan vóór de sectie-markup worden uitgevoerd; daarom ook
     op DOMContentLoaded initialiseren. init() is idempotent. */
  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
